import { render, staticRenderFns } from "./v-gridform-builder-sort.vue?vue&type=template&id=fb3f6fec&"
import script from "./v-gridform-builder-sort.vue?vue&type=script&lang=js&"
export * from "./v-gridform-builder-sort.vue?vue&type=script&lang=js&"
import style0 from "./v-gridform-builder-sort.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports